<template>
    <div id="language-selector" v-if="isEnabled">
      <div v-for="lang in languages" v-bind:class="{ active: lang.locale === selectedLanguage }"  v-on:click="changeLanguage(lang.locale)">
        {{ lang.label }}
      </div>
    </div>
</template>

<script>
  export default {
    name: "language-selector",
    data() {
      return {
        languages: [
          {
            label: "عربي",
            locale: 'ar'
          },
          {
            label: "English",
            locale: 'en'
          }
        ]
      }
    },
    computed: {
      selectedLanguage() {
        return this.$i18n.locale
      },
      isEnabled () {
        return !['Kit', 'KitCategory'].includes(this.$route.name)
      }
    },
    methods: {
      changeLanguage(lang) {
        this.$i18n.locale = lang
      }
    }
  }
</script>

<style lang="stylus">
  #language-selector
    z-index 100
    width: 140px
    border: 1px solid #55CCAA
    display flex
    border-radius 5px
    align-items center
    height 28px
    div
      flex 1 1 50px
      text-align center
      cursor : pointer;
      color: #707070
      display: flex;
      max-height: 30px;
      height: 30px;
      vertical-align: middle;
      justify-content: center
      align-items center
      &:last-child
        border-left: 1px solid #55CCAA
      &.active
        font-weight bold
        color: #55CCAA
@media only screen and (min-width: 768px)
  #language-selector
    width: 100%
    border: 1px solid #c4c4c4
    div
      text-align center
      cursor : pointer;
      color: #c4c4c4
      &:last-child
        border-left: 1px solid #c4c4c4
      &.active
        color: #c4c4c4


</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue